/**
 * FTP'deki dosyayı URL vererek siler (Vercel Serverless Function aracılığıyla)
 * @param url Silinecek dosyanın public URL'si (örneğin: https://image.ayvalikmarin.com.tr/gallery/123.jpg)
 */
export async function deleteFromFtp(url: string | null | undefined): Promise<void> {
  if (!url) return;

  try {
    const response = await fetch("/api/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ url }), // Send URL as JSON body
    });

    if (!response.ok) {
      const err = await response.json();
      console.error("FTP Silme Hatası:", err.error || "Bilinmeyen hata");
      // Bilerek throw atmıyoruz. 
      // FTP'den silinemese bile (eski URL kırık vb. durumlar) kullanıcının DB'den silme işlemi başarılı olmaya devam etsin.
    }
  } catch (error) {
    console.error("FTP Silme API Bağlantı Hatası:", error);
  }
}
